module.exports = __webpack_public_path__ + "img/female_A_03.7f003cd6.png";